import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./tabs/tabs.module').then((m) => m.TabsPageModule),
  },
  {
    path: 'oauth/callback',
    loadChildren: () =>
      import('./pages/redirect/redirect.module').then(
        (m) => m.RedirectPageModule
      ),
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./pages/login/login.module').then((m) => m.LoginPageModule),
  },
  {
    path: 'ricette',
    loadChildren: () =>
      import('./pages/ricette/ricette.module').then((m) => m.RicettePageModule),
  },
  {
    path: 'animale',
    loadChildren: () =>
      import('./pages/my-client/cliente/animale/animale.module').then(
        (m) => m.AnimalePageModule
      ),
  },
  {
    path: 'cliente',
    loadChildren: () =>
      import('./pages/my-client/cliente/cliente.module').then(
        (m) => m.ClientePageModule
      ),
  },
  {
    path: 'my-shop',
    loadChildren: () =>
      import('./pages/my-shop/my-shop.module').then((m) => m.MyShopPageModule),
  },
  {
    path: 'impostazioni',
    loadChildren: () =>
      import('./pages/impostazioni/impostazioni.module').then(
        (m) => m.ImpostazioniPageModule
      ),
  },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
